import React, { useState, useEffect } from "react";
import { Button, Modal, Form, Row, Col } from "react-bootstrap";
import { Icon } from '@iconify/react';
import { Dropdown } from 'primereact/dropdown';
import { useAuth } from '../../../context/useAuth';
import api from '../../../services/apiIdz';

import "./NewModelo.scss";
import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';

function NewModelo({ show, handleAlert, tipoVeiculo = 1 }) {
  const { token } = useAuth();
  const [showModal, setShowModal] = useState(false);

  const [marcas, setMarcas] = useState([]);
  const [categorias, setCategorias] = useState([]);

  const handleClose = () => setShowModal(false);

  // abre/fecha modal conforme prop
  useEffect(() => { if (show) setShowModal(true); }, [show]);

  // estado do form do modal
  const [popupData, setPopupData] = useState({
    tipo_veiculo: Number(tipoVeiculo) || 1, // 1=carro, 2=moto
    categoria: '',
    marca_id: '',
    modelo: '',
    versao: '',
    fabricacao: '',
    ultimo: ''
  });

  // mantém em sincronia se o pai mudar tipoVeiculo enquanto o modal está aberto
  useEffect(() => {
    setPopupData(prev => ({ ...prev, tipo_veiculo: Number(tipoVeiculo) || 1 }));
  }, [tipoVeiculo]);

  const handlePopupData = (value, field) => {
    setPopupData(prev => ({ ...prev, [field]: value }));
  };


  // recarrega marcas quando categoria OU tipo_veiculo mudarem
  useEffect(() => {
    // limpa marca quando muda categoria/tipo
    if (popupData.marca_id) {
      setPopupData(prev => ({ ...prev, marca_id: '' }));
    }
    getMarcas(popupData.categoria, popupData.tipo_veiculo);
  }, [popupData.categoria, popupData.tipo_veiculo]);

  // ====== APIs ======
  const getMarcas = async (categoriaId, tipo) => {
    try {
      const params = { tipo_veiculo: Number(tipo) || 1 };
      if (categoriaId) params.categoria = categoriaId;

      const r = await api.get(`/api/marcas`, {
        headers: { 'Authorization': process.env.REACT_APP_API_KEY },
        params
      });

      if (r.data && Array.isArray(r.data)) {
        const lista = [];
        for (let marca of r.data) {
          const ativo = (marca.status === undefined) || (marca.status === 1) || (marca.status === "Ativo");
          const bateCategoria = !categoriaId || !('categoria_id' in marca) || String(marca.categoria_id) === String(categoriaId);
          if (ativo && bateCategoria) lista.push({ label: marca.titulo, value: marca.id });
        }
        setMarcas(lista);
      } else {
        setMarcas([]);
      }
    } catch (e) {
      console.error("Erro ao buscar marcas:", e);
      setMarcas([]);
    }
  };

  const getCategorias = async (tipo) => {
    try {
      const params = { tipo_veiculo: Number(tipo) || 1 };

      const r = await api.get(`/api/modelos/categoria`, {
        headers: { 'Authorization': process.env.REACT_APP_API_KEY },
        params
      });

      if (r.data && Array.isArray(r.data)) {
        const lista = r.data
          .filter(cat => cat.status === 1 || cat.status === "Ativo")
          .map(cat => ({ label: cat.titulo, value: cat.id }));
        setCategorias(lista);
      } else {
        setCategorias([]);
      }
    } catch (e) {
      console.error("Erro ao buscar categorias:", e);
      setCategorias([]);
    }
  };

  useEffect(() => {
    if (popupData.tipo_veiculo) {
      getCategorias(popupData.tipo_veiculo);
    } else {
      setCategorias([]);
    }
  }, [popupData.tipo_veiculo]);

  const postModelo = async () => {
    try {
      const dataToSend = {
        ...popupData,
        tipo_veiculo: Number(popupData.tipo_veiculo) || 1
      };

      const r = await api.post(`/api/modelos`, dataToSend, {
        headers: { 'Authorization': process.env.REACT_APP_API_KEY, "Token": token }
      });

      if (typeof r.data === 'string') {
        handleAlert("Campos inválidos", r.data, "danger");
      } else if (r.status === 200) {
        handleAlert("Sucesso", "Os dados foram cadastrados com êxito.", "success");
        handleClose();
      } else {
        handleAlert("Erro", "Não foi possível salvar o modelo.", "danger");
      }
    } catch (e) {
      console.error("Erro ao cadastrar modelo:", e);
      handleAlert("Erro", "Falha na comunicação com o servidor.", "danger");
    }
  };

  return (
    <>
      <Modal show={showModal} className="NewModelo">
        <Modal.Header>
          <Modal.Title>Cadastro de Modelos</Modal.Title>
          <Icon icon="ri:edit-fill"></Icon>
        </Modal.Header>
        <Modal.Body>
          <Form>
            {/* Tipo de veículo */}
            <Form.Group className="mb-3">
              <Form.Label className='Label'>
                <span>Tipo de veículo</span>
                <Dropdown
                  value={popupData.tipo_veiculo}
                  onChange={(e) => handlePopupData(Number(e.value), "tipo_veiculo")}
                  options={[
                    { label: "Carro", value: 1 },
                    { label: "Moto",  value: 2 }
                  ]}
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Selecione o tipo"
                  className='Dropdown'
                />
              </Form.Label>
            </Form.Group>

            {/* Categoria */}
            <Form.Group className="mb-3">
              <Form.Label className='Label'>
                <span>Categoria</span>
                <Dropdown
                  filter
                  value={popupData.categoria}
                  onChange={(e) => handlePopupData(e.value, "categoria")}
                  options={categorias}
                  optionLabel="label"
                  optionValue="value"
                  placeholder="Categorias"
                  className='Dropdown'
                  disabled={!popupData.tipo_veiculo} // desabilita até escolher o tipo
                  emptyMessage={
                    !popupData.tipo_veiculo
                      ? "Selecione o tipo de veículo primeiro"
                      : "Nenhuma categoria encontrada"
                  }
                />
              </Form.Label>
            </Form.Group>

            {/* Marca */}
            <Form.Group className="mb-3">
              <Form.Label>Marca</Form.Label>
              <Dropdown
                filter
                value={popupData.marca_id}
                onChange={(e) => handlePopupData(e.value, "marca_id")}
                options={marcas}
                optionLabel="label"
                optionValue="value"
                placeholder="Marca"
                className='Dropdown'
                disabled={!popupData.categoria}
                emptyMessage={popupData.categoria ? "Nenhuma marca encontrada" : "Selecione uma categoria"}
              />
            </Form.Group>

            {/* Modelo */}
            <Form.Group className="mb-3">
              <Form.Label>Nome do Modelo</Form.Label>
              <Form.Control
                value={popupData.modelo}
                onChange={(e) => handlePopupData(e.target.value, "modelo")}
                type="text"
                placeholder="Informe o modelo"
              />
            </Form.Group>

            {/* Versão */}
            <Form.Group className="mb-3">
              <Form.Label>Nome da Versão</Form.Label>
              <Form.Control
                value={popupData.versao}
                onChange={(e) => handlePopupData(e.target.value, "versao")}
                type="text"
                placeholder="Informe a versão"
              />
            </Form.Group>

            {/* Anos */}
            <Row>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Primeiro ano de fabricação</Form.Label>
                  <Form.Control
                    value={popupData.fabricacao}
                    onChange={(e) => handlePopupData(e.target.value, "fabricacao")}
                    type="text"
                    placeholder="Informe o ano"
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label>Último ano de fabricação</Form.Label>
                  <Form.Control
                    value={popupData.ultimo}
                    onChange={(e) => handlePopupData(e.target.value, "ultimo")}
                    type="text"
                    placeholder="Informe o ano"
                  />
                </Form.Group>
              </Col>
            </Row>

            {/* Ações */}
            <Form.Group className="text-center">
              <Button variant="primary" className="Btns ButtonPrimaryLight" onClick={postModelo}>
                Salvar
              </Button>
            </Form.Group>
            <Form.Group className="text-center">
              <Button variant="secondary" className="Btns ButtonLight" onClick={handleClose}>
                Fechar
              </Button>
            </Form.Group>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default NewModelo;
